import { Currency } from '@/core/currency/interfaces';

const KYD: Currency = {
    name: 'Cayman Islands Dollar',
    demonym: 'Cayman Islands',
    majorSingle: 'Dollar',
    majorPlural: 'Dollars',
    codeNumeric: '136',
    symbol: 'CI$',
    symbolNative: '$',
    minorSingle: 'Cent',
    minorPlural: 'Cents',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'KYD',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default KYD;
